var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1282 9.73369C20.9825 10.3616 20.9825 11.6381 20.1282 12.266L18.7279 13.2954C18.2567 13.6416 18.0168 14.2209 18.1052 14.7989L18.3699 16.5318C18.5301 17.58 17.6274 18.4827 16.5792 18.3225L14.8462 18.0578C14.2682 17.9695 13.689 18.2094 13.3427 18.6805L12.3134 20.0808C11.6854 20.9352 10.409 20.9352 9.78105 20.0808L8.75173 18.6805C8.40544 18.2094 7.82622 17.9695 7.24823 18.0578L5.51527 18.3225C4.46707 18.4827 3.5644 17.58 3.72454 16.5318L3.9893 14.7989C4.0776 14.2209 3.8377 13.6416 3.36659 13.2954L1.96624 12.266C1.11192 11.6381 1.11192 10.3616 1.96624 9.73369L3.36659 8.70437C3.8377 8.35808 4.0776 7.77886 3.9893 7.20087L3.72454 5.4679C3.5644 4.4197 4.46707 3.51703 5.51527 3.67717L7.24824 3.94193C7.82622 4.03024 8.40544 3.79034 8.75173 3.31922L9.78105 1.91887C10.409 1.06456 11.6854 1.06456 12.3134 1.91888L13.3427 3.31922C13.689 3.79034 14.2682 4.03024 14.8462 3.94193L16.5792 3.67717C17.6274 3.51703 18.5301 4.4197 18.3699 5.4679L18.1052 7.20087C18.0168 7.77886 18.2567 8.35808 18.7279 8.70437L20.1282 9.73369Z",
    fill: "#0A0C13",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0466 14.9916C13.2515 14.9916 15.039 13.2041 15.039 10.9992C15.039 8.79428 13.2515 7.00684 11.0466 7.00684C8.84165 7.00684 7.0542 8.79428 7.0542 10.9992C7.0542 13.2041 8.84165 14.9916 11.0466 14.9916Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3a955398ccd8c4cb550a72610010e0b3.svg";
export { ForwardRef as ReactComponent };